import React, {useEffect} from "react";
import "./ServiceAndOffer.scss";
import type {TabsProps} from "antd";
import {Tabs} from "components/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import OfferList from "./components/OfferList/OfferList";
import Services from "./components/Services/Services";
import Chart from "./components/AdvancedReport/Chart";

const items: TabsProps["items"] = [
  {
    key: tabKeys.SERVICE_AND_OFFER.OFFER_LIST,
    label: `Danh sách chương trình ưu đãi`,
    children: <OfferList />,
  },
  {
    key: tabKeys.SERVICE_AND_OFFER.SERVICE_LIST,
    label: `Danh sách dịch vụ`,
    children: <Services />,
  },
  {
    key: tabKeys.SERVICE_AND_OFFER.ADVANCE_REPORT,
    label: `Báo cáo nâng cao`,
    children: <Chart />,
  },
];

const ServiceAndOffer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setButtonsHeader([]))
  }, []);
  const activeTab = useAppSelector(state => state.common.activeTab);

  useEffect(() => {
  }, [activeTab]);
  return (
    <div className="service-and-offer page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default ServiceAndOffer;
